export function isDefined<T>(
  argument: T | null | undefined,
): argument is NonNullable<T> {
  return typeof argument !== 'undefined' && argument !== null;
}
